var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTapeLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 311,
    viewBox: "0 0 1440 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1831_46062)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1637,
    height: 188.78,
    transform: "matrix(-0.996195 -0.0871557 -0.0871557 0.996195 1504.72 143.03)",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.766044 -0.642787 -0.642787 0.766044 1589.66 124.426)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.766044 -0.642787 -0.642787 0.766044 1336.12 102.244)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.766044 -0.642787 -0.642787 0.766044 1082.57 80.0615)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.766044 -0.642787 -0.642787 0.766044 829.027 57.8789)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.766044 -0.642787 -0.642787 0.766044 575.482 35.6973)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.766044 -0.642787 -0.642787 0.766044 321.937 13.5146)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.766044 -0.642787 -0.642787 0.766044 68.3916 -8.66797)",
    fill: "#FBD34E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1831_46062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1637,
    height: 188.78,
    fill: "white",
    transform: "matrix(-0.996195 -0.0871557 -0.0871557 0.996195 1504.72 143.03)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapeLeft);
export default __webpack_public_path__ + "static/media/tape-left.ccf6bb7d7ea9adf7f11d3fa640285558.svg";
export { ForwardRef as ReactComponent };